import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

import type { RequestGetCountryInterface } from "./countryServiceInterface/countryInterface";
import { RequestGetCountryOfPassportInterface } from "./countryServiceInterface/countryOfPassportInterface";

class CountryServiceApi {
  private baseUrl: string;

  private basePath: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "v2/country/Country";
  }

  // https://goapi.travels.network/api/v2/country/Country/getCountry
  // ******************************************************
  // ****************** Method: POST **********************
  // ******************************************************
  async getCountry(params: RequestGetCountryInterface) {
    return apiRequest(
      this.baseUrl,
      `${this.basePath}/getCountry`,
      "POST",
      params,
    );
  }

  // {{host}}/api/utilities/CountryOfPassportList
  // async getCountryOfPassport() {
  //   return apiRequest(this.baseUrl, `utilities/CountryOfPassportList`, "GET");
  // }
  async getCountryOfPassport(): Promise<RequestGetCountryOfPassportInterface> {
    const response = (await apiRequest(
      this.baseUrl,
      `utilities/CountryOfPassportList`,
      "GET",
    )) as any;
    return new RequestGetCountryOfPassportInterface(response);
  }

  async getCountryOfPassportAndLocalCountry(): Promise<RequestGetCountryOfPassportInterface> {
    const response = (await apiRequest(
      this.baseUrl,
      `v2/CountryOfPassportList`,
      "GET",
    )) as any;
    return new RequestGetCountryOfPassportInterface(response);
  }
}

export default CountryServiceApi;
